interface IOrder {
  createOrderFrom: string | null
  customer: string | null
  customerName: string | null
  customerAbbreviationName: string | null
  customerAddress: null
  contact: string | null
  contactName: string | null
  logisticContact: string | null
  logisticContactName: string | null
  idQuoteAndCharge: string | null
  quote: string | null
  quoteCode?: string | null
  quoteName: string | null
  charge: string | null
  chargeName: string | null
  chargeData: { [key: string]: any }
  productivityOrder: number | null
  workingTimeRequest: string[]
  transportation: string | null
  positions: { [key: string]: any }[]
  quoteData?: { [key: string]: any }
  condition: { [key: string]: any }[]
  waitingTasks: { [key: string]: any }[]
  allotted?: number | null
  businessOpportunity: string | null
  businessOpportunityName: string | null
  commodityName: string | null
  commodity: string | null
  request: string | null,
  notYetDistributionNumber: number | null,
  noBooking: null | string,
  routingPositions?: { [key: string]: any } | null,
  containerNumbers: string[],
  typeInputContainerNumbers: string,
  fileContainerNumbers: { [key: string]: any }
}

interface IOrderByCustomerRequest {
  positions: { [key: string]: any }[]
  commodity: string | null
  commodityName: string | null
  businessOpportunity: string | null
  workflow: string | null
  workflowData: []
  weightCommodity: number | null
  tasks: [
    {
      code: ''
      value: null
    }
  ]
  requestSpecial: string | null
  mergeContainer: boolean
  headContainer: boolean
  businessOpportunityName: string | null
  contCategory: string | null
  vehicleCategory: string | null
  contName: string | null
  vehicleCategoryName: string | null
  workflowName: string | null
  productivity: number | null
  transportation: string | null
  allotted?: number | null,
  noBooking: null | string,
  quoteData?: { [key: string]: any },
  routingPositions?: { [key: string]: any } | null,
  shippingPlanStatus?: number,
  containerCode?: string,
  truckOrderCode?: string
}

const initDataAddOrder: IOrder = {
  createOrderFrom: 'QUOTE',
  customer: null,
  customerName: null,
  customerAbbreviationName: null,
  customerAddress: null,
  contact: null,
  contactName: null,
  logisticContact: null,
  logisticContactName: null,
  idQuoteAndCharge: null,
  quote: null,
  quoteName: null,
  quoteCode: null,
  charge: null,
  chargeName: null,
  chargeData: {} as { [key: string]: any },
  workingTimeRequest: [],
  productivityOrder: null,
  transportation: null,
  positions: [],
  condition: [],
  waitingTasks: [] as { [key: string]: any }[],
  allotted: null,
  businessOpportunity: null,
  businessOpportunityName: null,
  commodityName: null,
  commodity: null,
  request: null,
  notYetDistributionNumber: null,
  noBooking: null,
  routingPositions: null,
  containerNumbers: [] as string[],
  typeInputContainerNumbers: '',
  fileContainerNumbers: {} as { [key: string]: any }
}

const initDataAddOrderByCustomerRequest: IOrderByCustomerRequest = {
  commodity: null,
  commodityName: null,
  businessOpportunity: '',
  workflow: '',
  workflowData: [],
  positions: [],
  productivity: null,
  weightCommodity: null,
  tasks: [
    {
      code: '',
      value: null
    }
  ],
  requestSpecial: '',
  mergeContainer: false,
  headContainer: false,
  businessOpportunityName: '',
  contCategory: '',
  vehicleCategory: '',
  contName: '',
  vehicleCategoryName: '',
  workflowName: '',
  transportation: null,
  allotted: null,
  noBooking: null,
  quoteData: {},
  routingPositions: null,
  containerCode: '',
  truckOrderCode: ''
}

const initFormAddDocument = {
  document: null,
  fileName: null,
  description: null,
  type: null,
  privacy: null
}

export default {
  initDataAddOrder,
  initDataAddOrderByCustomerRequest,
  initFormAddDocument
}
